import { render, staticRenderFns } from "./GestioneZone.vue?vue&type=template&id=50bec9a9&"
import script from "./GestioneZone.vue?vue&type=script&lang=js&"
export * from "./GestioneZone.vue?vue&type=script&lang=js&"
import style0 from "./GestioneZone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports